import { useEffect } from "react";
import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import HotSearch from "@/pages/home/components/HotSearch";
import EventRank from "@/pages/home/components/EventRank";
import CategoryRank from "@/pages/home/components/CategoryRank";
import TopicSection from "@/pages/home/components/TopicSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import BackToTop from "@/pages/home/components/BackToTop";

const siteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "吃瓜热门",
  inLanguage: "zh-CN",
  description: "吃瓜热门实时汇总全网今日热点、热搜榜、事件排行与热点排行，按热度或时间一键切换，实时刷新不漏掉网上热瓜。",
  url: typeof window !== "undefined" ? window.location.origin : "/",
};

export default function Home() {
  useEffect(() => {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.href.split("#")[0]);
  }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <TopNav />
      <main>
        <Hero />
        <HotSearch />
        <EventRank />
        <CategoryRank />
        <TopicSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}